import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { Outlet } from "react-router-dom";
import { BlockerNoticeNotActive } from "./noticeBlockerNotActive.js";
import { ConfigHintModal } from "../hintModal.js";
const BlockerLayout = observer(()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BlockerNoticeNotActive, {
                style: {
                    margin: "10px 0 0 0"
                }
            }),
            /*#__PURE__*/ _jsx(Outlet, {}),
            /*#__PURE__*/ _jsx(ConfigHintModal, {
                identifier: "blocker"
            })
        ]
    });
});
export { BlockerLayout };
